var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-row',[_c('el-col',[_c('h1',[_vm._v("错误,页面不存在!")])])],1),_c('el-row',[_c('el-col',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }